module.exports = __webpack_public_path__ + "media/images/empty/search-72325dc31e0ed8dcd100483b75b6d6ed.svg";